import { message } from 'antd';
import { queryNotices, checkCode, infoCode } from '../services/api';
import { notification } from 'antd';
import { routerRedux } from 'dva/router';


export default {
  namespace: 'global',

  state: {
    collapsed: false,
    notices: [],
  },

  effects: {
    *fetchNotices(_, { call, put, select }) {
      const data = yield call(queryNotices);
      yield put({
        type: 'saveNotices',
        payload: data,
      });
      const unreadCount = yield select(
        state => state.global.notices.filter(item => !item.read).length
      );
      yield put({
        type: 'user/changeNotifyCount',
        payload: {
          totalCount: data.length,
          unreadCount,
        },
      });
    },
    *clearNotices({ payload }, { put, select }) {
      yield put({
        type: 'saveClearedNotices',
        payload,
      });
      const count = yield select(state => state.global.notices.length);
      const unreadCount = yield select(
        state => state.global.notices.filter(item => !item.read).length
      );
      yield put({
        type: 'user/changeNotifyCount',
        payload: {
          totalCount: count,
          unreadCount,
        },
      });
    },
    *changeNoticeReadState({ payload }, { put, select }) {
      const notices = yield select(state =>
        state.global.notices.map(item => {
          const notice = { ...item };
          if (notice.id === payload) {
            notice.read = true;
          }
          return notice;
        })
      );
      yield put({
        type: 'saveNotices',
        payload: notices,
      });
      yield put({
        type: 'user/changeNotifyCount',
        payload: {
          totalCount: notices.length,
          unreadCount: notices.filter(item => !item.read).length,
        },
      });
    },
    *checkCode({ payload, callback }, { put, call }) {
      try {
        const res = yield call(checkCode, payload, false);
        console.log('*checkCode -> res', res);
        if (res) {
          callback(res, 'true')
        }
      } catch (error) {
        console.log('*checkCode -> error', error);
          try {
            error.json().then(b => {
              callback(b, 'false')
            })
          } catch (error) {
            error.text().then(b => {
              callback(b, 'false')
            });
          }
      }
    },
    *infoCode({ payload, callback }, { put, call }) {
      try {
        const res = yield call(infoCode, payload, false);
        // console.log('*checkCode -> res', res);
        if (res) {
          callback(res, 'info');
        }
      } catch (error) {
        console.log('*checkCode -> error', error);
        try {
          error.json().then(b => {
            callback(b, 'info');
          });
        } catch (error) {
          error.text().then(b => {
            callback(b, 'info');
          });
        }
      }
    },
  },

  reducers: {
    changeLayoutCollapsed(state, { payload }) {
      return {
        ...state,
        collapsed: payload,
      };
    },
    saveNotices(state, { payload }) {
      return {
        ...state,
        notices: payload,
      };
    },
    saveClearedNotices(state, { payload }) {
      return {
        ...state,
        notices: state.notices.filter(item => item.type !== payload),
      };
    },
  },

  subscriptions: {
    setup({ history }) {
      // Subscribe history(url) change, trigger `load` action if pathname is `/`
      return history.listen(({ pathname, search }) => {
        if (typeof window.ga !== 'undefined') {
          window.ga('send', 'pageview', pathname + search);
        }
      });
    },
  },
};
